import * as types from "./mutationTypes";

export default {
  [types.SET_BLOCKRULE](state, blockrule) {
    state.blockrule = blockrule;
  },
  [types.CLEAR_BLOCKRULE](state) {
    state.blockrule = null;
  },
  [types.SET_BLOCKRULES](state, blockrules) {
    state.blockrules = blockrules;
  },
  [types.CLEAR_BLOCKRULES](state) {
    state.blockrules = null;
  },
  [types.SET_TOTAL_BLOCKRULES](state, total) {
    state.totalBlockrules = total;
  },
  [types.CLEAR_TOTAL_BLOCKRULES](state) {
    state.totalBlockrules = null;
  },
  [types.REMOVE_BLOCKRULE](state, uuid) {
    state.blockrules = state.blockrules.filter((blockrule) => blockrule.uuid !== uuid);
  },
  [types.SET_FIELD](state, { field, value }) {
    state.blockrule[field] = value;
  },
  [types.SET_CUSTOMERS_BLOCKED](state, customers) {
    state.customersBlocked = customers;
  },
  [types.CLEAR_CUSTOMERS_BLOCKED](state) {
    state.customersBlocked = null;
  },
  [types.SET_TOTAL_CUSTOMERS_BLOCKED](state, total) {
    state.totalCustomersBlocked = total;
  },
  [types.CLEAR_TOTAL_CUSTOMERS_BLOCKED](state) {
    state.totalCustomersBlocked = null;
  }
};
